import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { groupDetailSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/groups/$groupId")({
  head: () => ({
    meta: [{ title: "小组详情 · imiker CRM" }],
  }),
  validateSearch: groupDetailSearchSchema,
  search: {
    middlewares: [stripSearchParams({ tab: "members" as const })],
  }
});
